import IngestionDiary from "../components/IngestionDiary";

export default function AdminIngestionDiary() {
  return (
    <div className="min-h-screen" data-testid="admin-ingestion-diary-page">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-4 sm:py-6">
        <IngestionDiary />
      </div>
    </div>
  );
}
